import { render, staticRenderFns } from "./YourSpaceCertificates.vue?vue&type=template&id=6530462c&scoped=true"
import script from "./YourSpaceCertificates.vue?vue&type=script&lang=js"
export * from "./YourSpaceCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530462c",
  null
  
)

export default component.exports